import Backbone from 'backbone';
import {getHTMLRepresentation, getStringRepresentation} from 'model/Kostenstelle';

const KOST_STRING_REPRESENTATION = 'KostenstelleStringRepresentation';
export const templateModel = new Backbone.Model({templateString: localStorage.getItem(KOST_STRING_REPRESENTATION) || ''});
// optimistic save last value (would not change often, user distinction may not be needed)
templateModel.listenTo(templateModel, 'change:templateString', (model, value) => localStorage.setItem(KOST_STRING_REPRESENTATION, value));

export const KostAttr = {
	getStringRepresentation: function (c) {
		return getStringRepresentation(c, templateModel.get('templateString'));
	},
	getHtmlRepresentation: function (c) {
		return getHTMLRepresentation(c, templateModel.get('templateString'));
	},
};